export default () => {
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0;
  }

  const projectSection = document.querySelector('.project_section');
  if (!projectSection) return;

  const topContainer = projectSection.querySelector('.project_section-container-top');
  if (!topContainer) return;

  const topList = topContainer.querySelector('.project-list');
  if (!topList) return;

  const topItems = topContainer.querySelectorAll('.project-item');
  if (!topItems.length) return;

  const bottomContainer = projectSection.querySelector('.project_section-container-bottom');
  if (!bottomContainer) return;

  const bottomList = bottomContainer.querySelector('.project-list');
  if (!bottomList) return;

  const bottomItems = bottomContainer.querySelectorAll('.project-item');
  if (!bottomItems.length) return;

  const numClones = 5;
  for (let i = 0; i < numClones; i++) {
    topItems.forEach((item) => {
      const clone = item.cloneNode(true);
      topList.appendChild(clone);
    });
  }

  for (let i = 0; i < numClones; i++) {
    bottomItems.forEach((item) => {
      const clone = item.cloneNode(true);
      bottomList.appendChild(clone);
    });
  }

  let itemWidth, originalTopWidth, originalBottomWidth;
  let positionTop, positionBottom;
  let animationId = null;
  let isAnimating = false;

  function calculateDimensions() {
    itemWidth = topItems[0].offsetWidth;

    originalTopWidth = topItems.length * itemWidth;
    originalBottomWidth = bottomItems.length * itemWidth;

    positionTop = -originalTopWidth;
    positionBottom = -originalBottomWidth;

    topList.style.transform = `translateX(${positionTop}px)`;
    bottomList.style.transform = `translateX(${positionBottom - itemWidth}px)`;
  }

  calculateDimensions();

  function animateSlider() {
    positionTop += 0.5;
    positionBottom += 0.5;

    if (positionTop >= 0) {
      positionTop = -originalTopWidth;
    }

    if (positionBottom >= 0) {
      positionBottom = -originalBottomWidth;
    }

    topList.style.transform = `translateX(${positionTop}px)`;
    bottomList.style.transform = `translateX(${positionBottom - itemWidth}px)`;
    animationId = requestAnimationFrame(animateSlider);
  }

  function startAnimation() {
    if (!isAnimating) {
      isAnimating = true;
      animationId = requestAnimationFrame(animateSlider);
    }
  }

  function stopAnimation() {
    if (isAnimating) {
      isAnimating = false;
      cancelAnimationFrame(animationId);
    }
  }

  function checkSliderVisibility() {
    if (isElementInViewport(projectSection)) {
      startAnimation();
    } else {
      stopAnimation();
    }
  }

  window.addEventListener('resize', function () {
    const wasAnimating = isAnimating;
    if (wasAnimating) {
      stopAnimation();
    }

    calculateDimensions();

    if (wasAnimating) {
      startAnimation();
    }
  });

  window.addEventListener('scroll', checkSliderVisibility);

  checkSliderVisibility();
};
